import { AlgoViteClientConfig, AlgoViteKMDConfig } from '../../interfaces/network'

export function getAlgodConfigFromViteEnvironment(): AlgoViteClientConfig {
  const server = import.meta.env.VITE_ALGOD_SERVER || 'https://mainnet-api.algonode.cloud'
  const port = import.meta.env.VITE_ALGOD_PORT || '443'
  const token = import.meta.env.VITE_ALGOD_TOKEN || ''
  const network = import.meta.env.VITE_ALGOD_NETWORK || import.meta.env.VITE_NETWORK || 'mainnet'

  return {
    server,
    port,
    token,
    network,
  }
}

export function getIndexerConfigFromViteEnvironment(): AlgoViteClientConfig {

  const server = import.meta.env.VITE_INDEXER_SERVER || 'https://mainnet-idx.algonode.cloud'
  const port = import.meta.env.VITE_INDEXER_PORT || ''
  const token = import.meta.env.VITE_INDEXER_TOKEN || ''
  const network = import.meta.env.VITE_ALGOD_NETWORK || 'mainnet'

  return { server, port, token, network }
}

export function getKmdConfigFromViteEnvironment(): AlgoViteKMDConfig {
  if (!import.meta.env.VITE_KMD_SERVER) {
    throw new Error('Attempt to get default kmd configuration without specifying VITE_KMD_SERVER in the environment variables')
  }

  return {
    server: import.meta.env.VITE_KMD_SERVER,
    port: import.meta.env.VITE_KMD_PORT,
    token: import.meta.env.VITE_KMD_TOKEN,
    wallet: import.meta.env.VITE_KMD_WALLET,
    password: import.meta.env.VITE_KMD_PASSWORD,
  }
}
